module.exports = __webpack_public_path__ + "img/nuvola_2.cb29baa9.png";